const userStore = {
  namespaced: true,
  state: {
    showGettingStarted: true,
    topNotificationBar: true,
    privateQueueMain: false,
    publicQueueMain: false,
    accountLocked: "",
    partners: {
      partner: {
        partnerID: '',
        partnerBalance: 0,
        partnerPercentage: 0
      }
    },
    activeBrowserSessions: 0,
    apiKey: "",
    authorizedIPs: [],
    browserNotifs: false,
    email: false,
    userName: "",
    ipRestrict: false,
    lastLoginIP: "",
    notificationEmail: "",
    notifications: [],
    notificationsEnabled: false,
    rememberMe: false,
    twoFactorAuthEnabled: false,
    verifiedEmail: false,
    role: "user",
    profilePic: "",
    authToken: "",
    loggedIn: false,
    authenticated: "",
    balance: 10,
    privateBid: 0,
    publicBid: 0,
    autoLoad: 0,
    autoLimit: 0,
    repRecognition: false,
    lowAmountNotificationFundAmount: 0,
    recogTimes: 0,
    filterProxies: false,
    resolvedProxies: false,
    referrals: {
      currentBalance: 0,
      referralLink: "",
      totalReferals: 0,
    },
    // securityScore: 0,
    totalFactoryDeployed: "",

    factoryAvgSpeed: "",
    publicAvgSpeed: "",
    privateAvgSpeed: "",

    fundsModal: false,
    publicBidModal: false,
    privateBidModal: false,
    friendRequestModal: false,
    notificationsModal: false,
    scheduledEventModal: false,
    accountSettingsBar: false,
    QRModal: false,
    manageFactoryModal: false,
    autoLoadModal: false,
    notificationDetailModal: false,
    factoryViewModal: true,
    partnerCashoutModal: false,
    referralCashoutModal: false,

    stripe: null,

    currentDetailedNotif: "",

    settingsPayload: {
      userName: null,
      notificationEmail: null,
      // browserNotification: null,
      // notificationEnabled: null,
      profilePic: null,
      lowAmountNotificationFund: null,
      twoFactorAuth: null,
      publicQueue: null,
      privateQueue: null,
      // factoryQueue: null
    },
  },
  mutations: {
    setTotalFactoryDeployed(state, totalFactoryDeployed) {
      state.totalFactoryDeployed = totalFactoryDeployed.toString()
    },
    setCurrentDetailedNotif(state, currentDetailedNotif) {
      state.currentDetailedNotif = currentDetailedNotif
    },
    setFactoryAvgSpeed(state, factoryAvgSpeed) {
      state.factoryAvgSpeed = factoryAvgSpeed
    },
    setPrivateAvgSpeed(state, privateAvgSpeed) {
      state.privateAvgSpeed = privateAvgSpeed
    },
    setPublicAvgSpeed(state, publicAvgSpeed) {
      state.publicAvgSpeed = publicAvgSpeed
    },
    setShowGettingStarted(state, gettingStarted) {
      state.showGettingStarted = gettingStarted
    },
    setTopNotifBar(state, topNotifBar) {
      state.topNotificationBar = topNotifBar;
    },
    setAutoLoad(state, autoLoad) {
      state.autoLoad = autoLoad;
    },
    setPublicQueue(state, publicQueueMain) {
      state.publicQueueMain = publicQueueMain;
    },
    setPrivateQueue(state, privateQueueMain) {
      state.privateQueueMain = privateQueueMain;
    },
    setAutoLimit(state, autoLimit) {
      state.autoLimit = autoLimit;
    },
    setReferralsDetail(state, referralDetail) {
      state.referrals = referralDetail;
    },
    setPartnerDetail(state, partnerDetails) {
      state.partners = partnerDetails;
    },
    setAccountLocked(state, accountLocked) {
      state.accountLocked = accountLocked;
    },
    setActiveBrowserSessions(state, activeBrowserSessions) {
      state.activeBrowserSessions = activeBrowserSessions;
    },
    setRole(state, role) {
      state.role = role;
    },
    setApiKey(state, apiKey) {
      state.apiKey = apiKey;
    },
    setAuthToken(state, authToken) {
      state.authToken = authToken;
    },
    setAuthorizedIPs(state, authorizedIPs) {
      state.authorizedIPs = authorizedIPs;
    },
    setBrowserNotifs(state, browserNotifs) {
      state.browserNotifs = browserNotifs;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setLoggedIn(state, loggedIn) {
      state.loggedIn = loggedIn;
    },
    setUsername(state, userName) {
      state.userName = userName;
    },
    setIpRestrict(state, ipRestrict) {
      state.ipRestrict = ipRestrict;
    },
    setLastLoginIp(state, lastLoginIP) {
      state.lastLoginIP = lastLoginIP;
    },
    setNotificationEmail(state, notificationEmail) {
      state.notificationEmail = notificationEmail;
    },
    setNotifications(state, notifications) {
      state.notifications = notifications;
    },
    setNotificationsEnabled(state, notificationsEnabled) {
      state.notificationsEnabled = notificationsEnabled;
    },
    setRememberMe(state, rememberMe) {
      state.rememberMe = rememberMe;
    },
    setTwoFactorAuthEnabled(state, twoFactorAuthEnabled) {
      state.twoFactorAuthEnabled = twoFactorAuthEnabled;
    },
    setVerifiedEmail(state, verifiedEmail) {
      state.verifiedEmail = verifiedEmail;
    },
    setAuthenticated(state, authenticated) {
      state.authenticated = authenticated;
    },
    setProfilePic(state, profilePic) {
      state.profilePic = profilePic;
    },
    setBalance(state, balance) {
      state.balance = balance;
    },
    setPrivatebid(state, privateBid) {
      state.privateBid = privateBid;
    },
    setSecurityScore(state, securityScore) {
      state.securityScore = securityScore;
    },
    setPublicbid(state, publicBid) {
      state.publicBid = publicBid;
    },
    setRepRecog(state, repRecognition) {
      state.repRecognition = repRecognition;
    },
    setRepCounts(state, recogTimes) {
      state.recogTimes = recogTimes;
    },
    setFilterProxies(state, filterProxies) {
      state.filterProxies = filterProxies;
    },
    setResolvedProxies(state, resolvedProxies) {
      state.resolvedProxies = resolvedProxies;
    },
    setFundsModal(state, fundsModal) {
      state.fundsModal = fundsModal;
    },
    setPublicBidModal(state, publicBidModal) {
      state.publicBidModal = publicBidModal;
    },
    setNotificationDetailModal(state, notificationDetailModal) {
      state.notificationDetailModal = notificationDetailModal;
    },
    setPrivateBidModal(state, privateBidModal) {
      state.privateBidModal = privateBidModal;
    },
    setFriendRequestModal(state, friendRequestModal) {
      state.friendRequestModal = friendRequestModal;
    },
    setNotificationsModal(state, notificationsModal) {
      state.notificationsModal = notificationsModal;
    },
    setQRModal(state, qrModal) {
      state.QRModal = qrModal;
    },
    setAutoLoadModal(state, autoLoadModal) {
      state.autoLoadModal = autoLoadModal
    },
    setReferralCashoutModal(state, referralCashoutModal) {
      state.referralCashoutModal = referralCashoutModal
    },
    setPartnerCashoutModal(state, partnerCashoutModal) {
      state.partnerCashoutModal = partnerCashoutModal
    },
    setScheduledEventModal(state, scheduledEventModal) {
      state.scheduledEventModal = scheduledEventModal;
    },
    setManageFactoryModal(state, manageFactoryModal) {
      state.manageFactoryModal = manageFactoryModal
    },
    setFactoryViewModal(state, factoryViewModal) {
      state.factoryViewModal = factoryViewModal;
    },
    setAccountSettingsBar(state) {
      for (var key of Object.keys(state.settingsPayload)) {
        if (state.settingsPayload[key] !== null) {
          state.accountSettingsBar = true;
          break;
        } else state.accountSettingsBar = false;
      }
    },

    // profile settings setters
    resetProfileSettings(state) {
      Object.keys(state.settingsPayload).forEach((v) => {
        state.settingsPayload[v] = null;
      });
    },
    setSettingsUsername(state, username) {
      state.settingsPayload.userName = username; // username
    },
    setSettingsTwoFactorAuth(state, twoFactorAuth) {
      state.settingsPayload.twoFactorAuth = twoFactorAuth; // twoFactorAuth
    },
    setSettingsBrowserNotifcations(state, browserNotification) {
      state.settingsPayload.browserNotification = browserNotification; // browserNotification
    },
    setSettingsNotificationEnabled(state, notificationEnabled) {
      state.settingsPayload.notificationEnabled = notificationEnabled; // notificationEnabled
    },
    setSettingsNotificationEmail(state, notificationEmail) {
      state.settingsPayload.notificationEmail = notificationEmail; // notificationEmail
    },
    setSettingsLowAmountNotificationFund(state, lowAmountNotificationFund) {
      state.settingsPayload.lowAmountNotificationFund = lowAmountNotificationFund; // lowAmountNotificationFund
    },
    setSettingsProfilePic(state, profilePic) {
      state.settingsPayload.profilePic = profilePic; // profilePic
    },
    setSettingsPublicQueue(state, publicQueue) {
      state.settingsPayload.publicQueue = publicQueue; // public queue
    },
    setSettingsPrivateQueue(state, privateQueue) {
      state.settingsPayload.privateQueue = privateQueue; // private queue
    },
    setSettingsFactoryQueue(state, factoryQueue) {
      state.settingsPayload.factoryQueue = factoryQueue; // factory queue
    },
    setLowFundNotificationAmount(state, lowAmountNotificationFundAmount) {
      state.lowAmountNotificationFundAmount = lowAmountNotificationFundAmount;
    },
    setStripe(state, stripe) {
      state.stripe = stripe;
    },

  },
  getters: {
    getTotalFactoryDeployed(state) {
      return state.totalFactoryDeployed;
    },
    getCurrentDetailNotif(state) {
      return state.currentDetailedNotif
    },
    getAutoLoadModal(state) {
      return state.autoLoadModal
    },
    getReferralCashoutModal(state) {
      return state.referralCashoutModal
    },
    getPartnerCashoutModal(state) {
      console.log(state);
      return state.partnerCashoutModal
    },
    getPrivateAvgSpeed(state) {
      return state.privateAvgSpeed
    },
    getPublicAvgSpeed(state) {
      return state.publicAvgSpeed
    },
    getFactoryAvgSpeed(state) {
      return state.factoryAvgSpeed
    },
    getManageFactoryModal(state) {
      return state.manageFactoryModal
    },
    getFactoryViewModal(state) {
      return state.factoryViewModal;
    },
    getShowGettingStarted(state) {
      return state.showGettingStarted
    },
    getTopNotificationBar(state) {
      return state.topNotificationBar
    },
    getEmail(state) {
      return state.email;
    },
    getUsername(state) {
      return state.userName;
    },
    getNotificationEmail(state) {
      return state.notificationEmail;
    },
    getNotificationEmailEnabled(state) {
      return state.notificationsEnabled;
    },
    getRole(state) {
      return state.role;
    },
    getApiKey(state) {
      return state.apiKey;
    },
    getAuthToken(state) {
      return state.authToken;
    },
    isAuthenticated(state) {
      return state.authenticated;
    },
    getTwoFactorAuthEnabled(state) {
      return state.twoFactorAuthEnabled;
    },
    getPrivateQueue(state) {
      return state.privateQueueMain;
    },
    getPublicQueue(state) {
      return state.publicQueueMain;
    },

    getActiveBrowserSessions(state) {
      return state.activeBrowserSessions;
    },
    isLoggedIn(state) {
      return state.loggedIn;
    },
    isVerified(state) {
      return state.verifiedEmail;
    },
    getBalance(state) {
      return state.balance;
    },
    getPublicBid(state) {
      return state.publicBid;
    },
    getPrivateBid(state) {
      return state.privateBid;
    },
    getAutoLoad(state) {
      return state.autoLoad;
    },
    getAutoLimit(state) {
      return state.autoLimit;
    },
    getRefDetail(state) {
      return state.referrals;
    },
    getPartnerDetails(state) {
      return state.partners;
    },
    getBrowserNotifs(state) {
      return state.browserNotifs;
    },

    getIp(state) {
      return state.lastLoginIP;
    },
    getSecurityScore(state) {
      return state.securityScore;
    },
    getLowAmountNotificationFund(state) {
      return state.lowAmountNotificationFund;
    },
    getFundsModal(state) {
      return state.fundsModal;
    },
    getProfilePic(state) {
      return state.profilePic;
    },
    getPublicBidModal(state) {
      return state.publicBidModal;
    },
    getQRModal(state) {
      return state.QRModal;
    },
    getNotificationDetailModal(state) {
      return state.notificationDetailModal
    },
    getPrivateBidModal(state) {
      return state.privateBidModal;
    },
    getFriendRequestModal(state) {
      return state.friendRequestModal;
    },
    getLowFundNotificationAmount(state) {
      return state.lowAmountNotificationFundAmount;
    },
    getNotificationsModal(state) {
      return state.notificationsModal;
    },
    getScheduledEventModal(state) {
      return state.scheduledEventModal;
    },
    getRepRecognition(state) {
      return state.repRecognition;
    },
    getRecogTimes(state) {
      return state.recogTimes;
    },
    getFilteredProxies(state) {
      return state.filterProxies;
    },
    getResolvedProxies(state) {
      return state.resolvedProxies;
    },
    getAccountSettingsBar(state) {
      return state.accountSettingsBar;
    },
    getSettingsPayload(state) {
      return state.settingsPayload;
    },
    getStripe(state) {
      return state.stripe;
    },
    getIpRestrict(state) {
      return state.ipRestrict
    },


  },
  actions: {
    toggleGettingStarted({ commit }, container) {
      commit("setShowGettingStarted", container)
    },
    toggleTopNotifBar({ commit }, container) {
      commit("setTopNotifBar", container)
    },
    toggleModal({ commit }, modal) {
      commit("setFundsModal", modal);
    },
    togglePublicBidModal({ commit }, modal) {
      commit("setPublicBidModal", modal);
    },
    togglePrivateBidModal({ commit }, modal) {
      commit("setPrivateBidModal", modal);
    },
    toggleFriendRequestModal({ commit }, modal) {
      commit("setFriendRequestModal", modal);
    },
    toggleNotificationsModal({ commit }, modal) {
      commit("setNotificationsModal", modal);
    },
    toggleScheduledEventModal({ commit }, modal) {
      commit("setScheduledEventModal", modal);
    },
    toggleQRModal({ commit }, modal) {
      commit("setQRModal", modal);
    },
    toggleRefferalCashoutModal({ commit }, modal) {
      commit('setReferralCashoutModal', modal)
    },
    togglePartnerCashoutModal({ commit }, modal) {
      commit('setPartnerCashoutModal', modal)
    },
    toggleManageFactoryModal({ commit }, modal) {
      commit('setManageFactoryModal', modal)
    },
    update({ commit }, user) {
      // console.log(user, " hehehe")
      commit("setRole", "user");
      commit("setEmail", user.email);
      commit("setVerifiedEmail", user.verifiedEmail);
      commit("setApiKey", user.apiKey);
      commit("setAuthorizedIPs", user.authorizedIPs);
      commit("setBrowserNotifs", user.browserNotifs);
      commit("setIpRestrict", user.ipRestrict);
      commit("setLastLoginIp", user.lastLoginIP);
      commit("setNotificationEmail", user.notificationEmail);
      commit("setNotifications", user.notifications);
      commit("setNotificationsEnabled", user.notificationsEnabled);
      commit("setRememberMe", user.rememberMe);
      commit("setAuthenticated", user.authenticated);
      commit("setLoggedIn", user.loggedIn);
      commit("setActiveBrowserSessions", user.activeBrowserSessions);
      commit("setUsername", user.userName);
      commit("setTwoFactorAuthEnabled", user.twoFactorAuthEnabled);
    },
    login({ commit }, user) {
      commit("setRole", "user");
      commit("setAuthToken", user.authToken);
      commit("setEmail", user.email);
      commit("setVerifiedEmail", user.verifiedEmail);
      commit("setApiKey", user.apiKey);
      commit("setAuthorizedIPs", user.authorizedIPs);
      commit("setBrowserNotifs", user.browserNotifs);
      commit("setIpRestrict", user.ipRestrict);
      commit("setLastLoginIp", user.lastLoginIP);
      commit("setNotificationEmail", user.notificationEmail);
      commit("setNotifications", user.notifications);
      commit("setNotificationsEnabled", user.notificationsEnabled);
      commit("setRememberMe", user.rememberMe);
      commit("setAuthenticated", user.authenticated);
      commit("setLoggedIn", user.loggedIn);
      commit("setActiveBrowserSessions", user.activeBrowserSessions);
      commit("setUsername", user.userName);
      commit("setTwoFactorAuthEnabled", user.twoFactorAuthEnabled);
    },

    logout({ commit }) {
      commit("setRole", "");
      commit("setAuthToken", "");
      commit("setEmail", "");
      commit("setVerifiedEmail", "");
      commit("setApiKey", "");
      commit("setAuthorizedIPs", "");
      commit("setBrowserNotifs", "");
      commit("setIpRestrict", "");
      commit("setLastLoginIp", "");
      commit("setNotificationEmail", "");
      commit("setNotifications", "");
      commit("setNotificationsEnabled", "");
      commit("setRememberMe", "");
      commit("setAuthenticated", "");
      commit("setLoggedIn", "");
      commit("setActiveBrowserSessions", "");
    },
  },
};

export default userStore;
